import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import Layout from "../../other/layout";
import SEO from "../../other/seo";
import { LINK_DISTRIBUTION, PREVIEW } from "../../project-config";
import { Link } from "gatsby";

export default function Index() {
  const data = useStaticQuery(graphql`
    query MenuQuery21 {
      allAvettiMenu {
        nodes {
          childs {
            name
            vid
            cid
            thumbnail
            image
            position
            description
            metadescription
            metakeywords
            URL
            childs {
              name
              vid
              cid
              thumbnail
              image
              position
              description
              metadescription
              metakeywords
              URL
            }
          }
        }
      }
    }
  `);
  console.info("Data2", data.allAvettiMenu.nodes);

  const handwrittenFormsChilds = data.allAvettiMenu.nodes[0].childs.find(
    f => f.URL === "computer-forms/"
  ).childs;

  return (
    <Layout>
      <SEO title="Computer Forms" />
      <h1 className="handwritten-forms-wrapper">Computer Forms</h1>
      <div className="handwritten-forms-wrapper">
        {handwrittenFormsChilds.map(c => {
          return (
            <div className="handwritten-form-item-wrapper">
              <Link to={`/${c.URL}`} className="handwritten-form-item">
                <span dangerouslySetInnerHTML={{ __html: c.name }}></span>
                <img
                  src={`${LINK_DISTRIBUTION}/store${c.thumbnail}`}
                  alt={"Image of " + c.name}
                ></img>
                <div className="handwritten-form-item-shop-btn">
                  <span>
                    Shop now<i className="material-icons">arrow_right</i>
                  </span>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
